import { createContext, useContext } from 'react';

import type { FilterCompositionStore } from '../store/filterCompositionStore.types.js';

/** @internal */
export interface FilterCompositionContextValue {
  id: string;
  /**
   * The composition store, resolved by `<FilterComposition>` from its `_store`
   * prop or an internally-created empty store. `undefined` only outside a
   * `<FilterComposition>` subtree.
   */
  store: FilterCompositionStore | undefined;
}

/** @internal */
export const FilterCompositionContext =
  createContext<FilterCompositionContextValue>({
    id: '',
    store: undefined,
  });

/** @internal */
export const useFilterCompositionContext = (): FilterCompositionContextValue =>
  useContext(FilterCompositionContext);
